import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import InfoCard from "../../../toolkit/InfoCard";
import MarkUnreadChatAltIcon from "@mui/icons-material/MarkUnreadChatAlt";
import NotificationsIcon from "@mui/icons-material/Notifications";
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import VisibilityIcon from '@mui/icons-material/Visibility';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import CancelIcon from '@mui/icons-material/Cancel';
import "./css/ClientDashboard.css";
import { Outlet, useLocation } from "react-router-dom";
import WidgetDrawer from "../../../components/Widget/WidgetDrawer";
import CircularProgress from "@mui/material/CircularProgress";
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';

import {
  Collapse,
  InputAdornment,
  ListItemButton,
  ListItemText,
  TextField,
  Card,
  Box,
  Grid,
  Stack,
  Divider,
  Button,
  Typography
} from "@mui/material";
import BaseURL from "../../../utils/base-uri.json";
import { Chart, ArcElement, Tooltip, Legend } from "chart.js";
// import  Test * as {Tooltip} *  from "@mui/material";
import { Tooltip as LeafletTooltip } from "@mui/material";
import { Doughnut } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import ButtonV1 from "../../../toolkit/ButtonV1";


import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import {
  AddCircleOutline,
  ExpandLess,
  ExpandMore,
  InsertDriveFileOutlined,
} from "@mui/icons-material";
import Mail from "../../../icons/Fastmail.svg";
import MailBlue from "../../../icons/mailBlue.svg";
import WriteDocument from "../../../icons/WriteDocument.svg";
import WriteDocumentBlue from "../../../icons/WriteDocumentBlue.svg";
import ProcessDocument from "../../../icons/ProcessDocument.svg";
import ProcessDocumentBlue from "../../../icons/ProcessDocumentBlue.svg";
import Clock from "../../../icons/Clock.svg";
import ClockBlue from "../../../icons/ClockBlue.svg";
import Eye from "../../../icons/Review.svg";
import EyeRed from "../../../icons/ReviewRed.svg";
import CheckCircle from "../../../icons/CheckCircle.svg";
import CheckCircleBlue from "../../../icons/CheckCircleBlue.svg";
import CancelCircle from "../../../icons/CancelCircle.svg";
import CancelCircleBlue from "../../../icons/CancelCircleBlue.svg";
import GraduationCap from "../../../icons/graduationCap.svg";
import GraduationBlue from "../../../icons/graduationBlue.svg";
import Information from "../../../icons/informationIcon.svg";
import InformationBlue from "../../../icons/informationIconBlue.svg";
import axios from "../../../utils/fvAxios";
import _debounce from 'lodash/debounce';
import SquareRoundedIcon from '@mui/icons-material/SquareRounded';
import OtherReports from "../CustomReport/AllOtherReports/OtherReports";
import { useNavigate } from "react-router-dom";
import { getOrgId, getstatuses, getToken } from "../../../utils/Token";
import SearchIcon from "@mui/icons-material/Search";
import TuneIcon from "../../../icons/Tune";
import { HasScreenPermissions, HasPermissions } from '../../../utils/Token';
import INFO from '../../../pages/commom/RouteUrlInfo.json';
import PER from "../../../utils/Enums.json";

Chart.register(ArcElement, ChartDataLabels, Tooltip);

function ClientDashboard() {
  const { t } = useTranslation();
  const [searchStr, setSearchStr] = useState("");
  const [searchStr1, setSearchStr1] = useState("");
  const [searchFocus, setSearchFocus] = useState(false);
  const [openItem, setOpenItem] = useState(null);
  const searchContainerRef = useRef(null);
  const [questionnaire, setQuestionnaire] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [Info, setInfo] = useState({});
  const [pie1, setpie] = useState([]);
  const [IsLoading, setIsLoading] = useState(false);
  const [isMessageCountLoading, setIsMessageCountLoading] = useState(true);
  const navigate = useNavigate();
  const ClientId = getOrgId();
  const [token, setToken] = useState(getToken())

  // Debounce the API call
  const debouncedSearch = _debounce((value) => {
    setPageNumber(1)
    if (value.length >= 3) {
      setSearchStr1(value)
      axios
        .get("Vendor/GetVendorSearch?pageNumber=" + pageNumber + "&pageSize=7&vendorName=" + value + "&clientId=" + ClientId)
        .then((res) => {
          if (res?.data?.responseCode === 100) {
            setQuestionnaire(res?.data?.data)
          } else {
            // setError(res.data.responseMessage);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {

        });
    } else if (value.length == 0) {
      setQuestionnaire([])

    }
  }, 500);
  const handleOnSearchChange = (event) => {
    const { value } = event.target;
    setSearchStr(value)

    // Reset the timer and debounce the API call
    clearTimeout(debouncedSearch.timerId);

    // Schedule the API call after 500ms if the user stops typing
    debouncedSearch.timerId = setTimeout(() => {
      debouncedSearch(value);
    }, 500);
  };

  useEffect(() => {
    const loadQuestionnaires = () => {
      setIsLoading(true);
      if (searchStr1) {
        axios
          .get("Vendor/GetVendorSearch?vendorName=" + searchStr1 + "&pageNumber=" + pageNumber + "&pageSize=7&clientId=" + ClientId)

          .then((res) => {
            if (res?.data?.responseCode === 100) {

              if (pageNumber === 1) {
                setQuestionnaire(res.data.data);
              } else {

                setQuestionnaire((prevQuestionnaire) => [...prevQuestionnaire, ...res.data.data]);
              }
              setHasMore(res?.data?.data?.length === 7);
            } else {
              // setError(res.data.responseMessage);
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {

          });
      }
    };

    loadQuestionnaires();
  }, [pageNumber]);

  const handleScroll = (e) => {

    const bottom = e.target.scrollTop + e.target.clientHeight + 1 >= e.target.scrollHeight;

    if (bottom && hasMore) {
      setPageNumber((prevPageNumber) => prevPageNumber + 1);
    }
  };



  useEffect(() => {
    const container = document.getElementById("#questionnaireContainer");
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
    };
  }, [handleScroll]);





  const handleClickOutside = (event) => {
    if (
      searchContainerRef.current &&
      !searchContainerRef.current.contains(event.target)
    ) {
      setSearchFocus(false);
    }
  };

  useEffect(() => {
    setIsLoading(true);
    axios.get("Prequalification/GetClientDashboardCounts")
      .then((res) => {
        if (res.data.responseCode === 100) {
          setInfo(res?.data?.data);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
      }).finally(() => {
        setIsLoading(false);
      })

    axios.get("Prequalification/GetClientDashboardPieData")
      .then((resp) => {
        if (resp.data.responseCode === 100) {
          setpie(resp?.data?.data);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
      }).finally(() => {
        setIsLoading(false);
      })

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };

  }, []);


  const StatusDescriptionList = getstatuses()
  const viewQuestionnaire = (e) => {
    navigate("/vendordetails?pqid=" + e);
  };

  // const mappedData = pie1.map((item) => ({
  //   phase: item.phase,
  //   prequalificationStatusName: item.prequalificationStatusName,
  //   prequalificationStatusId: item.prequalificationStatusId,
  //   recordCount: item.recordCount,
  //   backgroundColor: status.find((r) => r.value === item.prequalificationStatusId).color ,
  // }));

  const handleOpen = (e, id) => {
    e.stopPropagation();
    setOpenItem((prevOpenItem) => (prevOpenItem === id ? null : id));

  };
  const options = {
    width: 1600,
    height: 1600,
    animation: {
      animateRotate: false,
      animateScale: false
    }
  };


  const phaseCounts = pie1?.reduce((acc, item) => {
    if (!acc[item.phase]) {
      acc[item.phase] = 0;
    }
    acc[item.phase] += item.recordCount;
    return acc;
  }, {});


  // Background colors for each phase
  const backgroundColors = {
    "Initial Phase": "#E4E7EC",
    "Intermediate Phase": "#8293AE",
    "Final Phase": "#627595"
  };
  const lables = [
    "Initial Phase",
    "Intermediate Phase",
    "Final Phase",
  ]




  // const data = {

  //   datasets: [
  //     {

  //       data: Object.values(phaseCounts),
  //       backgroundColor: Object.keys(phaseCounts).map(phase => backgroundColors[phase]),
  //       hoverBackgroundColor: Object.keys(phaseCounts).map(phase => backgroundColors[phase]),
  //       datalabels: {
  //         color: "#ffff",
  //         font: {
  //           size: 0,
  //           weight: "bold",
  //         },
  //         backgroundColor: function (context) {
  //           return context.dataset.borderColor;
  //         },
  //         textAlign: "center",
  //       },
  //     },

  //     {
  //       labels: pie1.map(item => item.prequalificationStatusName),
  //       data: pie1.map(item => item.recordCount),
  //       backgroundColor: pie1.map(item => {
  //         switch (item.phase) {
  //           case "Initial Phase":
  //             switch (item.prequalificationStatusId) {
  //               case 15:
  //                 return "#B42318";
  //               case 3:
  //                 return "#D92D20";
  //               case 5:
  //                 return "#F04438";
  //               default:
  //                 return "#FFFFFF";
  //             }
  //           case "Intermediate Phase":
  //             switch (item.prequalificationStatusId) {
  //               case 16:
  //                 return "#F79009";
  //               case 7:
  //                 return "#FDB022";
  //               case 14:
  //                 return "#FEC84B";
  //               case 33:
  //                 return "#FEDF89";
  //               case 23:
  //                 return "#FEF0C7";
  //               case 4:
  //                 return "#B42318";
  //               case 32:
  //                 return "#B42318";
  //               default:
  //                 return "#FFFFFF"; // Default color if no specific match
  //             }
  //           case "Final Phase":
  //             switch (item.prequalificationStatusId) {
  //               case 7:
  //                 return "#EE3F3F";
  //               case 14:
  //                 return "#667085";
  //               case 33:
  //                 return "#B42318";
  //               case 23:
  //                 return "#D92D20";
  //               case 26:
  //                 return "#F79009";
  //               case 25:
  //                 return "#FDB022";
  //               case 24:
  //                 return "#FEC84B";
  //               case 13:
  //                 return "#FEDF89";
  //               case 8:
  //                 return "#EE3F3F";
  //               case 9:
  //                 return "#12B76A";
  //               case 8:
  //                 return "#E4E7EC";
  //               case 10:
  //                 return "#E4E7EC";
  //               case 32:
  //                 return "#B42318";
  //               default:
  //                 return "#FFFFFF"; // Default color if no specific match
  //             }
  //           default:
  //             return "#FFFFFF"; // Default color if no specific match
  //         }
  //       }),
  //       hoverBackgroundColor: pie1.map(item => {
  //         // Use the same logic as backgroundColor to generate hoverBackgroundColor
  //         switch (item.phase) {
  //           case "Initial Phase":
  //             // Switch statement for prequalificationStatusId
  //             switch (item.prequalificationStatusId) {
  //               case 15:
  //                 return "#B42318";
  //               case 3:
  //                 return "#D92D20";
  //               case 5:
  //                 return "#F04438";
  //               default:
  //                 return "#FFFFFF"; // Default color if no specific match
  //             }
  //           case "Intermediate Phase":

  //             switch (item.prequalificationStatusId) {
  //               case 16:
  //                 return "#F79009";
  //               case 7:
  //                 return "#FDB022";
  //               case 14:
  //                 return "#FEC84B";
  //               case 33:
  //                 return "#FEDF89";
  //               case 23:
  //                 return "#FEF0C7";
  //               case 4:
  //                 return "#B42318";
  //               case 32:
  //                 return "#B42318";
  //               default:
  //                 return "black";
  //             }
  //           case "Final Phase":

  //             switch (item.prequalificationStatusId) {
  //               case 7:
  //                 return "#EE3F3F";
  //               case 14:
  //                 return "#667085";
  //               case 33:
  //                 return "#B42318";
  //               case 23:
  //                 return "#D92D20";
  //               case 26:
  //                 return "#F79009";
  //               case 25:
  //                 return "#FDB022";
  //               case 24:
  //                 return "#FEC84B";
  //               case 13:
  //                 return "#FEDF89";
  //               case 8:
  //                 return "#EE3F3F";
  //               case 9:
  //                 return "#12B76A";
  //               case 8:
  //                 return "#E4E7EC";
  //               case 10:
  //                 return "#E4E7EC";
  //               case 32:
  //                 return "#B42318";
  //               default:
  //                 return "black";
  //             }
  //           default:
  //             return "#FFFFFF"; // Default color if no specific match
  //         }
  //       }), datalabels: {
  //         color: "#ffff",
  //         font: {
  //           size: 0,
  //           weight: "bold",
  //         },


  //         backgroundColor: function (context) {
  //           return context.dataset.borderColor;
  //         },
  //         textAlign: "center",
  //       },

  //     }
  //   ],
  // };



  const reportData = [
    {
      key: 3,
      value: "Clients List",
      url: BaseURL?.baseReportUrl + "Clients.aspx",
      type: 2,
      Show: true,
    },
    {
      key: 4,
      value: "Vendors By Submitted Date",
      url: BaseURL?.baseReportUrl + "VendorBySubmitted.aspx",
      type: 1,
      Show: true,
    },
    {
      key: 5,
      value: "Locked Questionnaires",
      url: BaseURL?.baseReportUrl + "LockedTemplates.aspx",
      type: 0,
      Show: true,
    },
    {
      key: 6,
      value: "Vendor Employee Training Summary",
      formsUrl: BaseURL?.baseReportUrl + "ExpiredDocumentWebForm.aspx",
      type: 4,
      Show: true,
    },
    {
      key: 7,
      value: "Subsection Report",
      formsUrl: BaseURL?.baseReportUrl + "SubSectionReport.aspx",
      type: 5,
      Show: true,
    },
    {
      key: 11,
      value: "Invitations Sent",
      formsUrl: BaseURL?.baseReportUrl + "InvitationsSent.aspx",
      type: 6,
      Show: true,
    },
    {
      key: 12,
      value: "Contractor Evaluations",
      formsUrl: BaseURL?.baseReportUrl + "ScoreCardReviews.aspx",
      type: 7,
      Show: true,
    },
    {
      key: 13,
      value: "Notifications",
      url: BaseURL?.baseReportUrl + "Notifications.aspx",
      type: 8,
      Show: true,
    },
    {
      key: 14,
      value: "Injury Statistics",
      formsUrl: BaseURL?.baseReportUrl + "InjuryStatisticsReport.aspx",
      type: 9,
      Show: true,
    },
  ];

  const [widgedVisible, setWidgedVisiblity] = useState(false);

  const handleWidgetDrawer = () => {
    setWidgedVisiblity(!widgedVisible);
  };

  const [radius, setRadius] = React.useState(135);
  const [skipAnimation, setSkipAnimation] = React.useState(true);

  const colorMapping = {
    "Pending": "#DD513B",
    "Pending-Renewal": "#C9412C",
    "Processing": "#EC6043",
    "Client Review": "#F37446",
    "Incomplete": "#FCAA5D",
    "N/A": "#C4D4E0",
    "No Response-Not Complete": "#50A2D8",
    "No Response-FV Request": "#50A2D8",
    "No Response-Expired Doc": "#50A2D8",
    "Probation": "#96C5B2",
    "Exception": "#188C76",
    "Not Prequalified": "#C03621",
    "Prequalified": "#126959",
    "Prequalified — Expired": "#BAD6D1",
    "BANNED": "#D8DFDE",
    "Final Phase": "#627595",
    "Initial Phase": "#E4E7EC",
    "Intermediate Phase": "#8293AE",
    "Expired": "red",
    "Training Only": "#ffef00"

  }
  const phaseColors = {
    "Final Phase": "rgb(185 187 190)",
    "Initial Phase": "rgb(233 233 233)",
    "Intermediate Phase": "rgb(214 214 214)"
  };
  // Function to get the color based on phase and prequalificationStatusId
  const getColor = (phase, prequalificationStatusId) => {
    if (phase === "Initial Phase") {
      switch (prequalificationStatusId) {
        case 15:
          return "#C9412C";
        case 3:
          return "#DD513B";
        case 5:
          return "#EC6043";
        default:
          return ""; // Default color
      }
    } else if (phase === "Intermediate Phase") {
      switch (prequalificationStatusId) {
        case 16:
          return "#F37446";
        case 7:
          return "#FCAA5D";
        case 14:
          return "#C4D4E0";
        case 33:
          return "#50A2D8";
        case 23:
          return "#FEF0C7";
        case 4:
          return "#50A2D8";
        case 32:
          return "#50A2D8";
        default:
          return "";// Default color
      }
    } else if (phase === "Final Phase") {
      switch (prequalificationStatusId) {
        case 7:
          return "#FCAA5D";
        case 14:
          return "#C4D4E0";
        case 33:
          return "#50A2D8";
        case 23:
          return "#50A2D8";
        case 26:
          return "#96C5B2";
        case 25:
          return "#FDB022";
        case 24:
          return "#FEC84B";
        case 13:
          return "#188C76";
        case 8:
          return "#C03621";
        case 9:
          return "#126959";
        case 8:
          return "#C03621";
        case 10:
          return "red";
        case 32:
          return "#50A2D8";
        case 31:
          return "#D8DFDE";
        case 4:
          return "#50A2D8";
        case 34:
          return "#ffef00";
        default:
          return "";  // Default color
      }
    } else {
      return "";
    }
  };
  const groupedPie = pie1?.reduce((acc, item) => {
    const phase = item.phase;
    if (!acc[phase]) {
      acc[phase] = [];
    }
    acc[phase].push(item);
    return acc;
  }, {});

  const totalCount = Object.values(phaseCounts).reduce((total, count) => total + count, 0);


  const intermediatePhaseCount = phaseCounts["Intermediate Phase"];
  const intermediatePhasePercentage = (intermediatePhaseCount / totalCount) * 100;
  const percentage = ((intermediatePhasePercentage / 100) * 450);

  const topPosition = intermediatePhasePercentage >= 30 ? -108 : (percentage <= 40 ? intermediatePhasePercentage - 450 : (-percentage - 100));




  const legendItems = Object.entries(groupedPie)?.map(([phase, items]) => {
    const totalRecordCount = items?.reduce((sum, item) => sum + item.recordCount, 0);
    return (
      <Box border={1}
        borderLeft={1}
        borderRight={1}

        borderColor="#e4e7ec">
        <div key={phase} >
          <div className=" p-2 " style={{ backgroundColor: "#F2F4F7", color: "#667085" }}>
            <b>{phase}</b> - Total Count: {totalRecordCount}
          </div>
          <table className="table table-bordered table-hover table-sm" >
            <tbody>
              {items?.map((item, index) => (
                <tr key={index}>
                  <td style={{ color: getColor(phase, item?.prequalificationStatusId), width: '33px' }}>
                    <SquareRoundedIcon />
                  </td>
                  <td style={{ width: '44px' }}>{item.recordCount}</td>
                  <td style={{ width: '100%', cursor: "help" }}>
                    <span>
                      <LeafletTooltip arrow placement="right-end" title={StatusDescriptionList?.find((r) => r?.prequalificationStatusId == item?.prequalificationStatusId)?.prequalificationDescription}>
                        <div>{item?.prequalificationStatusName}</div>
                      </LeafletTooltip></span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Box>
    );
  });

  return (
    <div style={{ padding: "20px" }}>
      <span
        style={{
          fontSize: "28px",
          fontWeight: "bold",
        }}
      >
        {t("Dashboard.dashboard")}
      </span>
      <div ref={searchContainerRef} className="search-container">
        <div className="flex-grow-1 input-wrapper">
          <TextField
            placeholder="Search Vendors by Name (in the results, click arrow for progress snapshot)"
            value={searchStr}
            onChange={handleOnSearchChange}
            fullWidth={true}
            className="search-input"
            onFocus={(e) => setSearchFocus(true)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <ButtonV1
                    leadingComponent={<TuneIcon />}
                    label={"Advanced Search"}
                    size="medium"
                    style={{
                      backgroundColor: "transparent",
                      border: "none",
                      color: "#2A93DB",
                    }}
                    onClick={() => {
                      navigate("/VendorSearch?clientId=" + ClientId + "&ID=1");
                    }}
                  />
                </InputAdornment>
              ),
            }}
          />
        </div>
        <ButtonV1
          hidden={HasScreenPermissions(INFO?.InviteVendor?.actionName)}
          label={"Invite a Vendor"}
          size="medium"
          style={{
            height: "100%",
          }}
          onClick={() => {
            navigate("/InviteVendor");
          }}
        />

        <div
          className={`search-result-container${searchFocus ? ` active` : ""}`}
          style={{ maxHeight: "300px", overflowY: "auto" }}
          id="#questionnaireContainer"
        >
          {questionnaire?.map((item) => (
            <div className="search-result-item" key={item?.vendorId} >
              <ListItemButton
                onClick={(e) => handleOpen(e, item?.vendorId)}
                className="search-result-item-header"
              >
                {openItem === item?.vendorId ? (
                  <ExpandLess className="expand-btn" />
                ) : (
                  <ExpandMore className="expand-btn" />
                )}
                <ListItemText
                  className="ml-2"
                  primary={item?.vendorName}
                  style={{ color: "#2A93DB", fontWeight: "600" }}
                />
                <ButtonV1
                  onClick={() => viewQuestionnaire(item?.prequalificationId)}
                  label={"View Questionnaire"}
                  size="medium"
                  style={{
                    backgroundColor: "transparent",
                    border: "none",
                    color: "#2A93DB",
                  }}
                />
              </ListItemButton>
              {/* <Collapse in={openItem === item?.vendorId} timeout="auto" unmountOnExit>
                <div className="expand-result-container">
                  <div className={`expand-result-item${item?.prequalificationStatusId == 1 ? " show" : ""}`} >
                    {item?.prequalificationStatusId == 1
                      ? <img src={MailBlue} alt="Mail" />
                      : <img src={Mail} alt="Mail" />}
                    <p>Vendor Invited</p>
                  </div>
                  <div className={`expand-result-item${[3, 15]?.includes(item?.prequalificationStatusId) ? " show" : ""}`} >
                    {[3, 15]?.includes(item?.prequalificationStatusId)
                      ? <img src={WriteDocumentBlue} alt="WriteDocument" />
                      : <img src={WriteDocument} alt="WriteDocument" />}
                    <p>Vendor started the questionnaire</p>
                  </div>
                  <div className={`expand-result-item${item?.prequalificationStatusId == 5 ? " show" : ""}`}>
                    {item?.prequalificationStatusId == 5
                      ? <img src={ProcessDocumentBlue} alt="ProcessDocument" />
                      : <img src={ProcessDocument} alt="ProcessDocument" />}
                    <p>Processing the questionnaire</p>
                  </div>
                  <div className={`expand-result-item${[4, 7, 32, 33]?.includes(item?.prequalificationStatusId) ? " show" : ""}`}>
                    {[4, 7, 32, 33]?.includes(item?.prequalificationStatusId)
                      ? <img src={ClockBlue} alt="Clock" />
                      : <img src={Clock} alt="Clock" />}
                    <p>Awaiting vendor response</p>
                  </div>
                  <div className={`expand-result-item${item?.prequalificationStatusId == 16 ? " showRed" : ""}`}>
                    {item?.prequalificationStatusId == 16
                      ? <img src={EyeRed} alt="Eye" className="redEye" />
                      : <img src={Eye} alt="Eye" className="redEye" />}
                    <p>Awaiting client response</p>
                  </div>
                  <div className={`expand-result-item${[9, 13, 26]?.includes(item?.prequalificationStatusId) ? " showGreen" : ""}`}>
                    {[9, 13, 26]?.includes(item?.prequalificationStatusId)
                      ? <img src={CheckCircleBlue} alt="CheckCircle" />
                      : <img src={CheckCircle} alt="CheckCircle" />}
                    <p>Approved</p>
                  </div>
                  <div className={`expand-result-item${[8, 10, 14, 31]?.includes(item?.prequalificationStatusId) ? " showRed" : ""}`}>
                    {[8, 10, 14, 31]?.includes(item?.prequalificationStatusId)
                      ? <img src={CancelCircleBlue} alt="CancelCircle" />
                      : <img src={CancelCircle} alt="CancelCircle" />}
                    <p>Not Approved</p>
                  </div>
                  <div className={`expand-result-item${[34]?.includes(item?.prequalificationStatusId) ? " show" : ""}`}>
                    {[34]?.includes(item?.prequalificationStatusId)
                      ? <img src={GraduationBlue} alt="GraduationCap" />
                      : <img src={GraduationCap} alt="GraduationCap" />}
                    <p>Training Only</p>
                  </div>
                  <div className={`expand-result-item${["Multiple"]?.includes(item?.status) ? " show" : ""}`}>
                    {["Multiple"]?.includes(item?.status)
                      ? <img src={InformationBlue} alt="Information" />
                      : <img src={Information} alt="Information" />}
                    <p>Information</p>
                  </div>
                </div>
              </Collapse> */}
              <Collapse in={openItem === item?.vendorId} timeout="auto" unmountOnExit>
                <div className="expand-result-container">
                  <div className={`expand-result-item${["Pending", "Pending-Renewal"]?.includes(item?.status) ? " show" : ""}`} >
                    {["Pending", "Pending-Renewal"]?.includes(item?.status)
                      ? <img src={WriteDocumentBlue} alt="WriteDocument" />
                      : <img src={WriteDocument} alt="WriteDocument" />}
                    <p>Vendor started the questionnaire</p>
                  </div>
                  <div className={`expand-result-item${item?.status == "Processing" ? " show" : ""}`}>
                    {item?.status == "Processing"
                      ? <img src={ProcessDocumentBlue} alt="ProcessDocument" />
                      : <img src={ProcessDocument} alt="ProcessDocument" />}
                    <p>Processing the questionnaire</p>
                  </div>
                  <div className={`expand-result-item${["No Response-Not Complete", "Incomplete", "No Response-Expired Doc", "No Response-FV Request"]?.includes(item?.status) ? " show" : ""}`}>
                    {["No Response-Not Complete", "Incomplete", "No Response-Expired Doc", "No Response-FV Request"]?.includes(item?.status)
                      ? <img src={ClockBlue} alt="Clock" />
                      : <img src={Clock} alt="Clock" />}
                    <p>Awaiting vendor response</p>
                  </div>
                  <div className={`expand-result-item${item?.status == "Client Review" ? " showRed" : ""}`}>
                    {item?.status == "Client Review"
                      ? <img src={EyeRed} alt="Eye" className="redEye" />
                      : <img src={Eye} alt="Eye" className="redEye" />}
                    <p>Awaiting client response</p>
                  </div>
                  <div className={`expand-result-item${["Prequalified", "Exception", "Probation"]?.includes(item?.status) ? " showGreen" : ""}`}>
                    {["Prequalified", "Exception", "Probation"]?.includes(item?.status)
                      ? <img src={CheckCircleBlue} alt="CheckCircle" />
                      : <img src={CheckCircle} alt="CheckCircle" />}
                    <p>Approved</p>
                  </div>
                  <div className={`expand-result-item${["Not Prequalified", "Expired", "N/A", "BANNED"]?.includes(item?.status) ? " showRed" : ""}`}>
                    {["Not Prequalified", "Expired", "N/A", "BANNED"]?.includes(item?.status)
                      ? <img src={CancelCircleBlue} alt="CancelCircle" />
                      : <img src={CancelCircle} alt="CancelCircle" />}
                    <p>Not Approved</p>
                  </div>
                  <div className={`expand-result-item${item?.status == "Training Only" ? " show" : ""}`}>
                    {item?.status == "Training Only"
                      ? <img src={GraduationBlue} alt="GraduationCap" />
                      : <img src={GraduationCap} alt="GraduationCap" />}
                    <p>Training Only</p>
                  </div>
                  <div className={`expand-result-item${item?.status == "Multiple" ? " show" : ""}`}>
                    {item?.status == "Multiple"
                      ? <img src={InformationBlue} alt="Information" />
                      : <img src={Information} alt="Information" />}
                    <p>View Questionnaire For Details</p>
                  </div>
                </div>
              </Collapse>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-4">
        <Card className="infoCard-container" style={{ padding: "20px" }}>
          {/* <Stack direction={"row"} spacing={5}>
            <div>
              <div className="infoCard-header">
                <MarkUnreadChatAltIcon />
                <p style={{ fontWeight: "bold" }}>{t("VendorDashboard.unread")}</p>
              </div>
              <div className="infoCard-description">
                <h3>{Info?.unreadMessages}</h3>
                <p className="infoCard-link" onClick={() => handleWidgetDrawer()}>
                  View all
                </p>

                <Box >
                  {widgedVisible && (
                    <WidgetDrawer
                      widgedVisible={widgedVisible}
                      onChangeVisibility={(resp) => setWidgedVisiblity(resp)}
                    />
                  )}
                  <Outlet />
                </Box>
              </div>
            </div>
            <Divider style={{ borderColor: "#667085" }} orientation="vertical" variant="middle" flexItem />
            <div>
              <div className="infoCard-header">
                <PeopleAltIcon />
                <p style={{ fontWeight: "bold" }}>{"Vendors invited"}</p>
              </div>
              <div className="infoCard-description">
                <h3>{Info?.vendorsInvited}</h3>
                <p className="infoCard-link" onClick={() => { navigate("/InviteVendor?tab=true") }}>
                  View all
                </p>
              </div>
            </div>
            <Divider style={{ borderColor: "#667085" }} orientation="vertical" variant="middle" flexItem />
            <div>
              <div className="infoCard-header">
                <VisibilityIcon />
                <p style={{ fontWeight: "bold" }}>{"Client review"}</p>
              </div>
              <div className="infoCard-description">
                <h3>{Info?.clientReview}</h3>
                <p className="infoCard-link" onClick={() => {
                  navigate("/VendorSearch?clientId=" + ClientId + "&status=true");
                }}>
                  View all
                </p>
              </div>
            </div>
            <Divider style={{ borderColor: "#667085" }} orientation="vertical" variant="middle" flexItem />
            <div>
              <div className="infoCard-header">
                <WarningRoundedIcon />
                <p style={{ fontWeight: "bold" }}>{"Expiring within the next 14 days"}</p>
              </div>
              <div className="infoCard-description">
                <h3>{Info?.expiringWithInNext14Days}</h3>
                <form action={BaseURL?.baseReportUrl + "ExpiringVendorsInnext14Days.aspx"} method="post"
                  target="_blank">
                  <input type="hidden" name="token" value={token} />
                  <input type="hidden" name="ClientId" value={ClientId} />
                  <Button type='submit' className="infoCard-link" sx={{ color: "#667085", textTransform: "capitalize", fontWeight: "bold", padding: "10px" }}>
                    {"View all"}
                  </Button>
                </form>
              </div>
            </div>
            <Divider style={{ borderColor: "#667085" }} orientation="vertical" variant="middle" flexItem />
            <div>
              <div className="infoCard-header">
                <CancelIcon />
                <p style={{ fontWeight: "bold" }}>{"Expired within past 31 days"}</p>
              </div>
              <div className="infoCard-description">
                <h3>{Info?.expiredWithInPast31Days}</h3>
                <form action={BaseURL?.baseReportUrl + "ExpiredVendorsInLast31days.aspx"} method="post"
                  target="_blank">
                  <input type="hidden" name="token" value={token} />
                  <input type="hidden" name="ClientId" value={ClientId} />
                  <Button type='submit' className="infoCard-link" sx={{ color: "#667085", textTransform: "capitalize", fontWeight: "bold", padding: "10px" }}>
                    {"View all"}
                  </Button>
                </form>
              </div>
            </div>

          </Stack> */}
          <Grid container spacing={0} alignItems="center">
            <Grid item xs={2} style={{ borderRight: "2px solid #E4E7EC" }}>
              <div style={{ padding: "5px", }} >
                <div className="infoCard-header">
                  <MarkUnreadChatAltIcon />
                  <p style={{ fontWeight: "bold" }}>{t("VendorDashboard.unread")}</p>
                </div>
                <div className="infoCard-description">
                  <h3>{Info?.unreadMessages}</h3>
                  <p className="infoCard-link" onClick={() => handleWidgetDrawer()}>
                    View All
                  </p>

                  <Box >
                    {widgedVisible && (
                      <WidgetDrawer
                        widgedVisible={widgedVisible}
                        onChangeVisibility={(resp) => setWidgedVisiblity(resp)}
                      />
                    )}
                    <Outlet />
                  </Box>
                </div>
              </div>

            </Grid>

            <Grid item xs={2} style={{ paddingLeft: "16px", borderRight: "2px solid #E4E7EC" }}>
              <div style={{ padding: "5px", }}>
                <div className="infoCard-header">
                  <PeopleAltIcon />
                  <p style={{ fontWeight: "bold" }}>{"Vendors invited"}</p>
                </div>
                <div className="infoCard-description">
                  <h3>{Info?.vendorsInvited}</h3>
                  {HasPermissions(INFO?.InviteVendor?.actionName, PER?.ScreenPermissions?.Read) ?
                    <p className="infoCard-link" onClick={() => { navigate("/InviteVendor?tab=true") }}>
                      View All
                    </p>
                    :
                    <p className="infoCard-link" onClick={() => { navigate("/ClientVendorsInvited") }}>
                      View All
                    </p>
                  }
                </div>
              </div>
            </Grid>

            <Grid xs={2} style={{ paddingLeft: "16px", borderRight: "2px solid #E4E7EC" }}>
              <div>
                <div className="infoCard-header">
                  <VisibilityIcon />
                  <p style={{ fontWeight: "bold" }}>{"Client review"}</p>
                </div>
                <div className="infoCard-description">
                  <h3>{Info?.clientReview}</h3>
                  <p className="infoCard-link" onClick={() => {
                    navigate("/VendorSearch?clientId=" + ClientId + "&status=true");
                  }}>
                    View All
                  </p>
                </div>
              </div>
            </Grid>
            <Grid xs={3} style={{ paddingLeft: "16px", borderRight: "2px solid #E4E7EC" }}>
              <div>
                <div className="infoCard-header">
                  <WarningRoundedIcon />
                  <p style={{ fontWeight: "bold" }}>{"Expiring within the next 14 days"}</p>
                </div>
                <div className="infoCard-description">
                  <h3>{Info?.expiringWithInNext14Days}</h3>
                  <form action={BaseURL?.baseReportUrl + "ExpiringVendorsInnext14Days.aspx"} method="post"
                    target="_blank">
                    <input type="hidden" name="token" value={token} />
                    <input type="hidden" name="ClientId" value={ClientId} />
                    <Button type='submit' className="infoCard-link" sx={{ color: "#667085", textTransform: "capitalize", fontWeight: "bold", padding: "10px" }}>
                      View all
                    </Button>
                  </form>
                </div>
              </div>
            </Grid>

            <Grid xs={3} style={{ paddingLeft: "16px", }}>
              <div>
                <div className="infoCard-header">
                  <CancelIcon />
                  <p style={{ fontWeight: "bold" }}>{"Expired within past 31 days"}</p>
                </div>
                <div className="infoCard-description">
                  <h3>{Info?.expiredWithInPast31Days}</h3>
                  <form action={BaseURL?.baseReportUrl + "ExpiredVendorsInLast31days.aspx"} method="post"
                    target="_blank">
                    <input type="hidden" name="token" value={token} />
                    <input type="hidden" name="ClientId" value={ClientId} />
                    <Button type='submit' className="infoCard-link" sx={{ color: "#667085", textTransform: "capitalize", fontWeight: "bold", padding: "10px" }}>
                      View All
                    </Button>
                  </form>
                </div>
              </div>
            </Grid>
          </Grid>
        </Card>
      </div>

      {/* <div className=" row mt-4  ">
        <div className="col-2">
          <InfoCard
            icon={<MarkUnreadChatAltIcon />}
            title={t("VendorDashboard.unread")}
            description={Info?.unreadMessages}
            link={handleItemClick}
          />
        </div>
        <div className="col-2">
          <InfoCard
            icon={<PeopleAltIcon />}
            title="Vendors invited"
            description={Info?.vendorsInvited}
            link={handleItemClick}
          />
        </div>
        <div className="col-2">
          <InfoCard
            icon={<VisibilityIcon />}
            title="Client review"
            description={Info?.clientReview}
            link={handleItemClick}
          />
        </div>
        <div className="col-3">
          <InfoCard
            icon={<WarningRoundedIcon />}
            title="Expiring within the next 14 days"
            description={Info?.expiringWithInNext14Days}
            link={handleItemClick}
          />
        </div>
        <div className="col-3">
          <InfoCard
            icon={<CancelIcon />}
            title="Expired within past 31 days"
            description={Info?.expiredWithInPast31Days}
            link={handleItemClick}
          />
        </div>
      </div> */}
      <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} style={{ marginTop: "10px" }}>

        <Grid item xs={12} sm={6} md={9} >
          <div>
            <Card className="card-container">
              <Card className="card-header" sx={{ backgroundColor: "#F2F4F7 !important" }}>
                <p style={{ margin: "0px", fontWeight: "bold" }}>
                  Vendors by prequalification status
                </p>
              </Card>
              <div style={{ paddingTop: "20px", paddingLeft: "20px", height: "900px" }} >

                {pie1?.length == 0
                  ? <Box sx={{ display: "flex", padding: "10px", height: "650px" }}>
                    <CircularProgress style={{ margin: "auto", }} />
                  </Box>
                  : <div className="pie">
                    <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 5, md: 18 }}>

                      <Grid item xs={12} sm={12} md={7} style={{ marginTop: "90px" }}>

                        {/* <div className="mt-3" style={{ justifyContent: "space-between", width: "289px" }}>
                          {phaseCounts["Final Phase"] > 0 &&
                            <span style={{ color: "#667085", fontWeight: "500", fontSize: 14, borderBottom: "2px solid #667085", top: "70px", position: "relative", left: "-11px" }}>FINAL PHASE:{phaseCounts["Final Phase"]}</span>
                          }
                          {phaseCounts["Initial Phase"] > 0 &&
                            <span style={{ color: "#667085", fontWeight: "500", fontSize: 14, borderBottom: "2px solid #667085", float: "right", top: "40px", position: "relative" }}>INITIAL PHASE:{phaseCounts["Initial Phase"]}</span>
                          }
                        </div> */}
                        <PieChart
                          height={500}
                          width={500}
                          slotProps={{ legend: { hidden: true } }}
                          series={[
                            {
                              data: pie1?.map(phase => ({
                                label: phase.prequalificationStatusName,
                                value: phase.recordCount,
                                color: colorMapping[phase.prequalificationStatusName],
                                active: true

                              })),
                              outerRadius: radius,
                              innerRadius: 39
                            },
                            {
                              data: Object.keys(phaseCounts).map(phase => ({
                                label: phase,
                                value: phaseCounts[phase],
                                color: phaseColors[phase] || "#000",
                              })),
                              innerRadius: radius,
                              // arcLabel: (params) => params.label ?? '',
                            },
                          ]}
                          skipAnimation={skipAnimation}
                          sx={{
                            [`& .${pieArcLabelClasses.root}`]: {
                              fill: 'white',
                              fontWeight: 'bold',
                            },
                          }}
                        />
                        {/* <div style={{ width: "561px" }}>
                          {phaseCounts["Intermediate Phase"] > 0 &&
                            <span style={{ color: "#667085", fontWeight: "500", fontSize: 14, borderBottom: "2px solid #667085", float: "right", top: topPosition, position: "relative" }}>INTERMEDIATE PHASE:{phaseCounts["Intermediate Phase"]}</span>
                          }</div> */}

                        <Stack spacing={1} >
                          <span>   {phaseCounts["Initial Phase"] > 0 &&
                            <span style={{ fontWeight: "500", fontSize: 14, marginTop: 0 }}>  <span ><SquareRoundedIcon style={{ color: "rgb(233 233 233)", }} /></span> INITIAL PHASE:{phaseCounts["Initial Phase"]}</span>
                          }</span><span>
                            {phaseCounts["Intermediate Phase"] > 0 &&
                              <span style={{ fontWeight: "500", fontSize: 14, marginTop: 0 }}>  <span ><SquareRoundedIcon style={{ color: "rgb(214 214 214)", }} /></span>  INTERMEDIATE PHASE:{phaseCounts["Intermediate Phase"]}</span>
                            }
                          </span>
                          <span> {phaseCounts["Final Phase"] > 0 &&
                            <span style={{ fontWeight: "500", fontSize: 14, marginTop: 0 }}>  <span><SquareRoundedIcon style={{ color: "rgb(185 187 190)", }} /></span> FINAL PHASE:{phaseCounts["Final Phase"]}</span>
                          }</span>
                        </Stack>
                      </Grid>

                      <Grid item xs={12} sm={12} md={5} sx={{ width: "100%" }}>
                        {legendItems}
                      </Grid>


                    </Grid>
                  </div>
                }
              </div>
            </Card >
          </div >
        </Grid >
        <Grid item xs={12} sm={6} md={3} >
          <div >
            <Card className="card-container" style={{ height: "950px" }}>
              <Card className="card-header" sx={{ backgroundColor: "#F2F4F7 !important" }}>
                <p style={{ margin: "0px", fontWeight: "bold" }}>Reports</p>
              </Card>
              <div className="flex-column" style={{ padding: "20px" }}>
                <h5>Custom reports</h5>
                <div className="report-item mb-4">
                  <a
                    // href={BaseURL?.baseReportUrl + "CreateReport.aspx"}

                    href={"/CustomReports"}
                    rel="noreferrer"
                    style={{ textDecoration: "none", color: "#2A93DB" }}
                  >
                    <AddCircleOutline /> Create Report
                  </a>
                </div>

                <h5>Predesigned reports</h5>
                <div className="report-map">
                  {/* {reportData.map((item) => (
                  <div className="report-item" key={item.key}>
                    <a
                      // href={item.url || item.formsUrl}
                      // target="_blank"
                      onClick={() => {
                        openInNewTab(item?.url, item?.type)
                        handleOpen(item?.url, item.formsUrl, item?.type);
                        setName(item?.value)
                        setType(item?.type)
                        setFormURL(item?.formsUrl)
                      }}
                      rel="noreferrer"
                      style={{ textDecoration: "none", color: "#2A93DB" }}
                    >
                      <InsertDriveFileOutlined /> {item.value}
                    </a>
                  </div>
                ))} */}
                  <OtherReports />
                </div>
              </div>
            </Card>
          </div>
        </Grid>
      </Grid >



    </div >
  );
}

export default ClientDashboard;
